<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot-scope="scope" slot="menu">
                <el-button type="text" size="small" icon="el-icon-check"
                           @click.stop="handleEdit(scope.row)"
                >分配权限
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="分配权限" :visible.sync="dialogFormVisible">
            <avue-form v-model="buttonForm" :option="buttonOption" @submit="buttonSubmit"></avue-form>
        </el-dialog>
    </div>
</template>

<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增角色', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'left', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          defaultExpandAll: true, // 展开全部
          column: [
            {
              label: '角色',
              prop: 'name',
              span: 14,
              rules: [{
                type: 'string', required: true, message: '角色不能为空', trigger: 'blur'
              }],
              search: true
            },
            {
              label: '显示名称',
              prop: 'display_name',
              span: 14,
              rules: [{
                type: 'string', required: true, message: '显示名称', trigger: 'blur'
              }]
            },
            {
              label: '描述',
              type: 'textarea',
              span: 24,
              prop: 'description'
            }
          ]
        },
        // 自定义按钮 配置
        dialogFormVisible: false,
        buttonForm: {
          permissions: [],
          row: []
        },
        buttonOption: {
          column: [{
            label: '选择权限',
            prop: 'permissions',
            props: {
              label: 'title',
              value: 'id'
            },
            span: 24,
            type: 'tree',
            multiple: true,
            dicUrl: this.config.baseURL + '/dic/permission',
            rules: [{
              type: 'array', required: true, message: '请选择权限', trigger: 'blur'
            }]
          }]
        }
      }
    },
    methods: {
      // 点击分配权限
      handleEdit(row) {
        this.buttonForm.row = row;
        // 拉取该角色已有权限
        this.api.get('/role/bind_permission', row).then(
          (re) => {
            if (re.code === 0) {
              this.buttonForm.permissions = re.data;
              this.dialogFormVisible = true
            }
          }
        )
      },
      // 分配权限提交
      buttonSubmit(form, done) {
        this.api.post('/role/bind_permission?id=' + this.buttonForm.row.id, form).then(
          (re) => {
            if (re.code === 0) {
              this.dialogFormVisible = false
              this.$message.success(re.msg)
            } else {
              this.$message.error(re.msg)
            }
            done()
          }
        )
      }
    }
  }
</script>
